// Following guide from https://stackoverflow.com/a/61188946

import type { ReactNode } from 'react'
import { createIntl, createIntlCache } from 'react-intl'
import type { IntlCache, IntlShape } from 'react-intl'
import type { IntlConfig } from '@formatjs/intl'

let cache: IntlCache | null = null
// eslint-disable-next-line import/no-mutable-exports
let intl: IntlShape

/**
 * Generate IntlShape object
 */
function generateIntl(config: IntlConfig<ReactNode>): IntlShape {
  if (cache !== null) {
    cache = null
  }

  cache = createIntlCache()

  intl = createIntl(config, cache)

  return intl
}

export { generateIntl, intl }
